<div class="mt-3">

</div>
<p class="alert alert-danger" role="alert">
  <i class="fa fa-times mr-2"></i> Número Whatsapp que você está logado, {{whatsappLogado | tel}},
  é diferente do número, {{whatsappConfigurado | tel}}, que está configurado na empresa .

</p>
